// ═══════════════════════════════════════════════
//   TAMAGOTCHI — alien care + storage + decay
// ═══════════════════════════════════════════════

const {S, ALIENS, COOLDOWNS, ACTION_PTS, SFX, addPts, toast, fmt, scheduleSave} = window;

// ══════════════════════════════════════════
// TAMAGOTCHI
// ══════════════════════════════════════════
let pendingDiscardUid = null;
let tamaReactionTimer = null;

// Use the player-chosen nickname when there is one; the species name
// is the fallback. Bubble/toast/decay messages all funnel through this
// so a renamed alien is referred to consistently.
const _displayName = a => a && (a.nickname || a.name);

function getTamaMood(a) {
    if (!a.alive) return { kaomoji: 'x_x', phrase: '{name} fainted...' };
    if (a.hunger < 20) return { kaomoji: '(>_<)', phrase: '{name} is so hungry...' };
    if (a.happiness < 20) return { kaomoji: '(;_;)', phrase: '{name} is feeling sad...' };
    if (a.energy < 20) return { kaomoji: '(-_-)', phrase: '{name} is sleepy...' };
    if (a.hunger > 80 && a.happiness > 80 && a.energy > 80) return { kaomoji: '(≧▽≦)', phrase: '{name} is having the best day ever! ♡' };
    return { kaomoji: '(^w^)', phrase: '{name} is happy to see you! ♡' };
}

function updateBubble(a, overrideReact) {
    const kaomojiEl = document.getElementById('tama-bubble-kaomoji');
    const msgEl = document.getElementById('tama-msg');
    if (!kaomojiEl || !msgEl) return;

    let kaomoji, phrase;
    if (overrideReact) {
        kaomoji = overrideReact.kaomoji;
        phrase = overrideReact.phrase;
    } else {
        const mood = getTamaMood(a);
        kaomoji = mood.kaomoji;
        phrase = mood.phrase;
    }
    
    const fullPhrase = phrase.replace('{name}', _displayName(a));

    if (kaomojiEl.textContent !== kaomoji || msgEl.textContent !== fullPhrase) {
        kaomojiEl.textContent = kaomoji;
        msgEl.textContent = fullPhrase;
        
        kaomojiEl.classList.remove('bubble-anim');
        requestAnimationFrame(() => kaomojiEl.classList.add('bubble-anim'));
    }
}

function tamaDecay() {
    S.myAliens.filter(a => S.activeTamaUids.includes(String(a.uid))).forEach(a => {
        if (!a.alive) return;
        a.hunger = Math.max(0, a.hunger - 2);
        a.happiness = Math.max(0, a.happiness - 1);
        a.energy = Math.max(0, a.energy - 1);
        if (a.hunger === 0 && a.happiness === 0) {
            a.alive = false;
            toast(`Oh no! ${_displayName(a)} fainted! 💀`);
        }
    });
    if (S.selTama) {
        S.selTama = S.myAliens.find(a => String(a.uid) === String(S.selTama.uid));
        updateTamaDisplay();
    }
    renderTamaSelect();
    window.updateProfileDisplay();
}

function setTamaTab(tab) {
    S.curTamaTab = tab;
    pendingDiscardUid = null;
    renderTamaSelect();
}

function renderTamaSelect() {
    const cont = document.getElementById('tama-select');
    const tabBar = `<div style="display:flex;gap:4px;margin-bottom:8px;">
    <button onclick="setTamaTab('care')" style="flex:1;padding:5px;font-family:'Press Start 2P',monospace;font-size:6px;border:2px solid var(--dark);border-radius:8px 8px 0 0;cursor:pointer;background:${S.curTamaTab === 'care' ? 'var(--pink)' : 'white'};color:${S.curTamaTab === 'care' ? 'white' : 'var(--dark)'};">🐾 CARE</button>
    <button onclick="setTamaTab('storage')" style="flex:1;padding:5px;font-family:'Press Start 2P',monospace;font-size:6px;border:2px solid var(--dark);border-radius:8px 8px 0 0;cursor:pointer;background:${S.curTamaTab === 'storage' ? 'var(--pink)' : 'white'};color:${S.curTamaTab === 'storage' ? 'white' : 'var(--dark)'};">🗃 STORAGE (${S.myAliens.length})</button>
  </div>`;
    if (S.curTamaTab === 'care') {
        if (S.myAliens.length === 0) {
            cont.innerHTML = tabBar + '<div class="tama-empty">Pull from the gacha<br>to get aliens!</div>';
            document.getElementById('tama-main').style.display = 'none';
            return;
        }
        const activeAliens = S.myAliens.filter(a => S.activeTamaUids.includes(String(a.uid)));
        let slots = '';
        for (let i = 0; i < S.maxTamaSlots; i++) {
            const a = activeAliens[i];
            if (a) {
                const al = ALIENS[a.alienId];
                const isSelected = S.selTama && String(S.selTama.uid) === String(a.uid);
                const displayName = a.nickname || a.name;
                slots += `<div class="tama-slot${isSelected ? ' on' : ''}" onclick="selectTama_byUid('${a.uid}')" style="position:relative;">
          <img src="${al ? al.img : ''}" alt="${displayName}" style="opacity:${a.alive ? 1 : .4}">
          <span>${displayName}</span>${a.alive ? '' : '<span class="tdead">💀</span>'}
          <button onclick="event.stopPropagation();removeFromCare('${a.uid}')" title="Move to storage" style="position:absolute;top:1px;right:1px;background:rgba(0,0,0,.35);color:white;border:none;border-radius:4px;font-size:8px;cursor:pointer;padding:0 3px;line-height:15px;">✕</button>
        </div>`;
            } else {
                slots += `<div class="tama-slot" style="opacity:.3;cursor:default;"><span style="font-size:18px;">+</span><span>empty</span></div>`;
            }
        }
        cont.innerHTML = tabBar + `<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:6px;margin-bottom:8px;">${slots}</div>`;
    } else {
        if (S.myAliens.length === 0) {
            cont.innerHTML = tabBar + '<div class="tama-empty">No aliens yet!<br>Pull from the gacha ✦</div>';
            return;
        }
        let items = '';
        S.myAliens.forEach(a => {
            const al = ALIENS[a.alienId];
            if (!al) return;
            const uidStr = String(a.uid);
            const isActive = S.activeTamaUids.includes(uidStr);
            const canAdd = S.activeTamaUids.length < S.maxTamaSlots;
            const isPending = pendingDiscardUid === uidStr;
            const rarityColor = {common: '#888', uncommon: '#60a5fa', rare: '#f5c842'}[al.rarity] || '#888';
            items += `<div style="display:flex;align-items:center;gap:8px;padding:7px 8px;background:white;border:2px solid ${isPending ? '#991b1b' : 'var(--dark)'};border-radius:10px;margin-bottom:5px;">
        <img src="${al.img}" style="width:42px;height:42px;object-fit:contain;opacity:${a.alive ? 1 : .4};flex-shrink:0;">
        <div style="flex:1;min-width:0;">
          <div style="font-family:'Press Start 2P',monospace;font-size:7px;color:var(--dark);">${a.nickname || a.name}</div>
          <div style="font-family:'Press Start 2P',monospace;font-size:5px;color:#aaa;margin-top:1px;">${a.nickname ? a.name : ''}</div>
          <div style="font-family:'Press Start 2P',monospace;font-size:5px;color:${rarityColor};margin-top:2px;">${al.rarity.toUpperCase()}${a.alive ? '' : ' · 💀 fainted'}</div>
        </div>
        <div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0;">
          ${isActive
                ? `<button onclick="removeFromCare('${uidStr}')" style="background:#7dd3fc;color:var(--dark);border:2px solid var(--dark);border-radius:6px;padding:3px 6px;font-family:'Press Start 2P',monospace;font-size:5px;cursor:pointer;white-space:nowrap;">✕ REMOVE</button>`
                : `<button onclick="addToCare('${uidStr}')" ${canAdd ? '' : 'disabled'} style="background:${canAdd ? 'var(--lime)' : '#eee'};color:var(--dark);border:2px solid var(--dark);border-radius:6px;padding:3px 6px;font-family:'Press Start 2P',monospace;font-size:5px;cursor:${canAdd ? 'pointer' : 'not-allowed'};white-space:nowrap;">${canAdd ? '▶ CARE' : '🔒 FULL'}</button>`}
          ${isPending
                ? `<button onclick="discardAlien('${uidStr}')" style="background:#991b1b;color:white;border:2px solid #991b1b;border-radius:6px;padding:3px 6px;font-family:'Press Start 2P',monospace;font-size:5px;cursor:pointer;white-space:nowrap;">⚠ CONFIRM?</button>`
                : `<button onclick="discardAlien('${uidStr}')" style="background:#ffb3b3;color:#991b1b;border:2px solid #991b1b;border-radius:6px;padding:3px 6px;font-family:'Press Start 2P',monospace;font-size:5px;cursor:pointer;white-space:nowrap;">🗑 DISCARD</button>`}
          <button onclick="renameAlien('${uidStr}')" style="background:#f0e6ff;color:#7c3aed;border:2px solid #7c3aed;border-radius:6px;padding:3px 6px;font-family:'Press Start 2P',monospace;font-size:5px;cursor:pointer;white-space:nowrap;">✏ RENAME</button>
        </div>
      </div>`;
        });
        cont.innerHTML = tabBar + `<div style="overflow-y:auto;">${items}</div>`;
        document.getElementById('tama-main').style.display = 'none';
    }
}

function selectTama_byUid(uid) {
    const uidStr = String(uid);
    S.selTama = S.myAliens.find(a => String(a.uid) === uidStr);
    if (!S.selTama) return;
    const al = ALIENS[S.selTama.alienId];
    document.getElementById('tama-main').style.display = 'flex';
    document.getElementById('tama-img').src = al ? al.img : '';
    document.getElementById('tama-name').textContent = S.selTama.nickname || S.selTama.name;
    document.getElementById('tama-subtitle').textContent = S.selTama.nickname ? S.selTama.name : 'alien companion';
    updateTamaDisplay();
    renderTamaSelect();
}

function selectTama(col) {
    selectTama_byUid(col.uid);
}

function addToCare(uid) {
    const uidStr = String(uid);
    if (S.activeTamaUids.length >= S.maxTamaSlots) {
        toast('No free slots! Unlock more in the shop ✦');
        return;
    }
    if (!S.activeTamaUids.includes(uidStr)) S.activeTamaUids.push(uidStr);
    S.curTamaTab = 'care';
    pendingDiscardUid = null;
    renderTamaSelect();
    scheduleSave();
    toast('Alien added to care! 🐾');
}

function removeFromCare(uid) {
    const uidStr = String(uid);
    S.activeTamaUids = S.activeTamaUids.filter(id => String(id) !== uidStr);
    if (S.selTama && String(S.selTama.uid) === uidStr) {
        S.selTama = null;
        document.getElementById('tama-main').style.display = 'none';
    }
    renderTamaSelect();
    scheduleSave();
}

function discardAlien(uid) {
    const uidStr = String(uid);
    if (pendingDiscardUid !== uidStr) {
        pendingDiscardUid = uidStr;
        renderTamaSelect();
        return;
    }
    pendingDiscardUid = null;
    const a = S.myAliens.find(x => String(x.uid) === uidStr);
    const name = a ? _displayName(a) : 'Alien';
    S.myAliens = S.myAliens.filter(x => String(x.uid) !== uidStr);
    S.activeTamaUids = S.activeTamaUids.filter(id => String(id) !== uidStr);
    if (S.selTama && String(S.selTama.uid) === uidStr) {
        S.selTama = null;
        document.getElementById('tama-main').style.display = 'none';
    }
    renderTamaSelect();
    window.updateProfileDisplay();
    scheduleSave();
    toast(`${name} was released 👋`);
}

function renameAlien(uid) {
    const uidStr = String(uid);
    const alien = S.myAliens.find(a => String(a.uid) === uidStr);
    if (!alien) return;
    const pop = document.createElement('div');
    pop.id = 'rename-pop';
    pop.style.cssText = 'position:fixed;inset:0;z-index:9500;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.65);';
    pop.innerHTML = `<div style="background:var(--cream);border:3px solid var(--dark);border-radius:14px;padding:20px;width:260px;box-shadow:5px 7px 0 var(--dark);">
    <div style="font-family:'Press Start 2P',monospace;font-size:8px;color:var(--pink);margin-bottom:10px;">✏ RENAME ALIEN</div>
    <div style="font-family:'Press Start 2P',monospace;font-size:6px;color:#aaa;margin-bottom:10px;">${alien.name}</div>
    <input id="rename-inp" type="text" maxlength="12" value="${alien.nickname || ''}" placeholder="nickname (max 12)"
      style="width:100%;padding:8px 12px;border-radius:20px;border:2px solid var(--pink);font-family:'Nunito',sans-serif;font-size:13px;font-weight:700;outline:none;color:var(--dark);background:linear-gradient(90deg,#ffb3d1,#fff8fb);margin-bottom:12px;">
    <div style="display:flex;gap:6px;">
      <button onclick="confirmRename('${uidStr}')" style="flex:1;background:var(--pink);color:white;border:2px solid var(--dark);border-radius:10px;padding:8px;font-family:'Press Start 2P',monospace;font-size:7px;cursor:pointer;">SAVE ♡</button>
      <button onclick="document.getElementById('rename-pop').remove()" style="flex:1;background:white;color:var(--dark);border:2px solid var(--dark);border-radius:10px;padding:8px;font-family:'Press Start 2P',monospace;font-size:7px;cursor:pointer;">CANCEL</button>
    </div>
  </div>`;
    document.body.appendChild(pop);
    const inp = document.getElementById('rename-inp');
    inp.focus();
    inp.select();
    inp.addEventListener('keydown', e => {
        if (e.key === 'Enter') confirmRename(uidStr);
        if (e.key === 'Escape') pop.remove();
    });
}

function confirmRename(uid) {
    const uidStr = String(uid);
    const alien = S.myAliens.find(a => String(a.uid) === uidStr);
    const inp = document.getElementById('rename-inp');
    if (!alien || !inp) return;
    const newName = inp.value.trim().toUpperCase().slice(0, 12);
    alien.nickname = newName || '';
    document.getElementById('rename-pop')?.remove();
    SFX.play('rename');
    toast(newName ? `Renamed to "${newName}"! 🏷️` : `Nickname cleared!`);
    if (S.selTama && String(S.selTama.uid) === uidStr) {
        document.getElementById('tama-name').textContent = newName || alien.name;
        document.getElementById('tama-subtitle').textContent = newName ? alien.name : 'alien companion';
    }
    renderTamaSelect();
    scheduleSave();
}

function updateTamaDisplay() {
    if (!S.selTama) return;
    const a = S.selTama;
    document.getElementById('tama-hfill').style.width = a.happiness + '%';
    document.getElementById('tama-ffill').style.width = a.hunger + '%';
    document.getElementById('tama-efill').style.width = a.energy + '%';
    
    if (document.getElementById('tama-hpct')) document.getElementById('tama-hpct').textContent = Math.round(a.happiness) + '%';
    if (document.getElementById('tama-fpct')) document.getElementById('tama-fpct').textContent = Math.round(a.hunger) + '%';
    if (document.getElementById('tama-epct')) document.getElementById('tama-epct').textContent = Math.round(a.energy) + '%';
    
    // Update the speech bubble (if no temporary reaction is active)
    if (!tamaReactionTimer) {
        updateBubble(a);
    }
    
    document.getElementById('tama-char').className = 'tama-char ' + (!a.alive ? 'dead' : a.happiness < 30 ? 'sad' : 'happy');
    const now = Date.now();
    [['feed', 'lastFed'], ['play', 'lastPlayed'], ['pet', 'lastPet'], ['sleep', 'lastSlept']].forEach(([action, field]) => {
        const btn = document.getElementById('btn-' + action);
        if (!btn) return;
        const rem = COOLDOWNS[action] - (now - (a[field] || 0));
        if (!a.alive) {
            btn.disabled = true;
            return;
        }
        if (rem > 0) {
            btn.disabled = true;
            btn.innerHTML = `<div class="btn-icon">⏳</div><div class="btn-text">${fmt(rem / 1000)}</div>`;
        } else {
            btn.disabled = false;
            const icons = {feed: '🍙', play: '🎮', pet: '🤍', sleep: '💤'};
            const texts = {feed: 'FEED', play: 'PLAY', pet: 'PET', sleep: 'REST'};
            btn.innerHTML = `<div class="btn-icon">${icons[action]}</div><div class="btn-text">${texts[action]}</div>`;
        }
    });
    clearTimeout(updateTamaDisplay._t);
    updateTamaDisplay._t = setTimeout(() => {
        if (S.selTama) updateTamaDisplay();
    }, 1000);
    if (window.renderToys) window.renderToys();
}

function tamaAction(action) {
    SFX.play('tama');
    if (!S.selTama || !S.selTama.alive) return;
    const now = Date.now(), fm = {feed: 'lastFed', play: 'lastPlayed', pet: 'lastPet', sleep: 'lastSlept'};
    if (now - (S.selTama[fm[action]] || 0) < COOLDOWNS[action]) {
        toast('Still on cooldown! ⏳');
        return;
    }
    S.selTama[fm[action]] = now;
    
    let react = null;
    const dn = _displayName(S.selTama);
    if (action === 'feed') {
        S.selTama.hunger = Math.min(100, S.selTama.hunger + 25);
        S.selTama.happiness = Math.min(100, S.selTama.happiness + 5);
        toast(`Fed ${dn}! +${ACTION_PTS.feed} pts 🍙`);
        react = { kaomoji: '(＊^▽^＊)', phrase: '{name} says yummy! ♡' };
        if (window.triggerMission) window.triggerMission('feed_alien');
    } else if (action === 'play') {
        S.selTama.happiness = Math.min(100, S.selTama.happiness + 25);
        S.selTama.energy = Math.max(0, S.selTama.energy - 15);
        toast(`Played with ${dn}! +${ACTION_PTS.play} pts 🎮`);
        react = { kaomoji: '\\(^o^)/', phrase: '{name} had so much fun!' };
    } else if (action === 'pet') {
        S.selTama.happiness = Math.min(100, S.selTama.happiness + 10);
        toast(`Petted ${dn}! +${ACTION_PTS.pet} pts 🤍`);
        react = { kaomoji: '(´• ω •｀)', phrase: '{name} feels warm fuzzies~' };
    } else if (action === 'sleep') {
        S.selTama.energy = Math.min(100, S.selTama.energy + 40);
        S.selTama.hunger = Math.max(0, S.selTama.hunger - 5);
        toast(`${dn} is resting! +${ACTION_PTS.sleep} pts 💤`);
        react = { kaomoji: '(＿ . ＿) z z', phrase: '{name} is resting... zzz' };
    }
    addPts(ACTION_PTS[action], `tama:${action}`);
    
    // Set temporary reaction bubble
    if (react) {
        clearTimeout(tamaReactionTimer);
        updateBubble(S.selTama, react);
        
        // Add pulse animation
        const charEl = document.getElementById('tama-char');
        if (charEl) {
            charEl.classList.remove('tpulse');
            requestAnimationFrame(() => charEl.classList.add('tpulse'));
        }
        
        tamaReactionTimer = setTimeout(() => {
            tamaReactionTimer = null;
            if (S.selTama) updateBubble(S.selTama);
        }, 2500);
    }
    
    updateTamaDisplay();
}

function resetTamaModal() {
    pendingDiscardUid = null;
}

window.resetTamaModal = resetTamaModal;
window.tamaDecay = tamaDecay;
window.setTamaTab = setTamaTab;
window.renderTamaSelect = renderTamaSelect;
window.selectTama_byUid = selectTama_byUid;
window.selectTama = selectTama;
window.addToCare = addToCare;
window.removeFromCare = removeFromCare;
window.discardAlien = discardAlien;
window.renameAlien = renameAlien;
window.confirmRename = confirmRename;
window.updateTamaDisplay = updateTamaDisplay;
window.tamaAction = tamaAction;
